import { Container, Button,Form, Alert, Modal} from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper} from "../ContentStyles";
import { FaUserPlus } from 'react-icons/fa';
import React, {useMemo, useState, useEffect } from 'react';
import {useNavigate} from 'react-router-dom';
import MaterialReactTable from 'material-react-table';
import useBackend, {Loading, SpinnerX} from '../../services/useBackend_v2';

var typingTimeout = null;

export default function MyComponent() {
    const {loading, data, Refresh, XCall, initReady, resultVisible, resultText, resultVariant} =  useBackend('/api/admin/customers');
    const defaultValues              = { Guid:null, Name:"", SSN:"", Banned:false, isAdmin:false, isAllIn:false, CustomerAge:0, eMail:"", initCompleted:false };
    const [editData, setEditData]    = useState(defaultValues);
    const [modalshow,  setModalshow] = useState(false);

    const navigate = useNavigate();

    async function handleChange(event){
        const DataForm = document.getElementById('DataForm');
        const formData = new FormData(DataForm);
        const formDataObj = Object.fromEntries(formData.entries());

        const newDataObj = { 
            Guid: editData.Guid, 
            Name: formDataObj.Name, 
            SSN: formDataObj.SSN, 
            Banned: formData.has('Banned') ? true : false, 
            isAdmin: formData.has('isAdmin') ? true : false, 
            isPrio: formData.has('isPrio') ? true : false, 
            CustomerAge: editData.CustomerAge,
            eMail: formDataObj.eMail,
            initCompleted: true
        };
        setEditData(newDataObj);
    }

    useEffect(() => {
        clearTimeout(typingTimeout);
        if (editData.Guid != null && editData.initCompleted) typingTimeout = setTimeout(handleSave, 475);
    }, [editData])

    async function handleSave(){
        if (editData.Guid == null) {
            let { errorsException } = await XCall('/api/admin/customers/', "POST", 3000, editData);
            if (!errorsException) {
                setTimeout(() => {
                    setModalshow(false); setEditData(defaultValues);
                    Refresh();
                }, 3000);
            }
        } else {
            let { errorsException } = await XCall('/api/admin/customers/'+editData.Guid, "PATCH", 3000, editData);
            if (!errorsException) Refresh();
        }
    }

    const showUserClick = (event, rowData)  =>  {
        setEditData(rowData.original);
        setModalshow(!modalshow);
    }
    
    const columns = useMemo(() => [
        { size: 20, accessorKey: 'SSN',   header: 'Personnummer', enableColumnActions: false },
        { size: 20, accessorKey: 'Name',  header: 'Namn' },
        { size: 20, accessorKey: 'eMail',  header: 'Email' },
        { size: 20, accessorKey: 'Banned',  header: 'Spärrad' },                 
      ]
    );       

    if (initReady) {
        return (
            <ContentWrapper>
                <Modal show={modalshow} onHide={() => { setModalshow(false); setEditData(defaultValues); }}>
                    <Modal.Header closeButton>
                        <Modal.Title>{editData.Name}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form id="DataForm">
                            <Form.Group className="mb-3" >
                                <Form.Label>Namn <small>{editData.SSN}</small></Form.Label>
                                <Form.Control type="text" name="Name" placeholder="Namn" defaultValue={editData.Name} onChange={handleChange} />
                            </Form.Group>

                            <Form.Group className="mb-3" >
                                <Form.Label>Email</Form.Label>
                                <Form.Control type="text" name="eMail" placeholder="Email" defaultValue={editData.eMail} onChange={handleChange} />
                            </Form.Group>

                            <Form.Group className="mb-3" >
                                <Form.Label>Personnummer</Form.Label>
                                <Form.Control type="text" name="SSN" placeholder="Personnummer" disabled={ editData.Guid == null ? false : true } defaultValue={editData.SSN} onChange={handleChange} />
                            </Form.Group>                            

                            <Form.Group className="mb-3" >
                                <Form.Label>Ålder</Form.Label>
                                <Form.Control type="text" name="age" placeholder="Ålder" defaultValue={editData.CustomerAge} disabled />
                            </Form.Group>
                        
                            <Form.Group className="mb-3" >
                                <Form.Check type="switch" name="Banned" id="Banned" label="Spärra användare" defaultChecked={editData.Banned} onChange={handleChange} />
                            </Form.Group>

                            <Form.Group className="mb-3" >
                                <Form.Check type="switch" name="isAdmin" id="isAdmin" label="Admin" defaultChecked={editData.isAdmin} onChange={handleChange} />
                            </Form.Group>

                            <Form.Group className="mb-3" >
                                <Form.Check type="switch" name="isPrio" id="isPrio" label="Priokund" defaultChecked={editData.isPrio} onChange={handleChange} />
                            </Form.Group>
                        </Form>

                        <Form.Group className="mb-3" hidden={!loading}>
                            <SpinnerX />
                        </Form.Group>

                        <Form.Group className="mb-3" hidden={!resultVisible}>
                            <Alert show={resultVisible} variant={resultVariant} className="FormSpace">{resultText}</Alert>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        { editData.Guid == null ? <>
                            <Button variant="danger" onClick={() => handleSave()}>Spara</Button>                            
                        </> : <>
                            <Button variant="_" onClick={()=>navigate("/customer/"+editData.Guid)}>Mer info</Button>                            
                        </> }
                        <Button variant="danger" onClick={() => { setModalshow(false); setEditData(defaultValues); }}>Close</Button>
                    </Modal.Footer>
                </Modal>

                <Container>
                    <Sida>
                        <MaterialReactTable  columns={columns} data={data.Customers}
                            muiTablePaginationProps={{ showFirstButton: false, showLastButton: false, labelRowsPerPage:"Rader"}}
                            initialState={{ pagination: { pageSize: 25 }, density: 'compact', columnVisibility: { Banned: false, eMail: false },  }}
                            muiTablePaperProps={{elevation: 0, sx: {borderRadius: '0',border: '0px dashed #e0e0e0'} }}
                            muiTableBodyRowProps={({ row }) => ({
                            onClick: (event) => {
                                showUserClick(event, row);
                                },
                                sx: {
                                    cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                },
                            })}

                            renderTopToolbarCustomActions= {() => ( <div style={{width:"100%"}}>
                                <div style={{float:"left"}}> <Rubrik>Kunder</Rubrik> </div>
                                <div style={{float:"right"}}><Button data={data.SoldProducts} onClick={() => {setEditData(defaultValues); setModalshow(!modalshow)}} variant="outlined" title='Exportera CSV'><FaUserPlus color="gray" /></Button></div>
                            </div>)}
                        />
                    </Sida>
                </Container>
            </ContentWrapper>
        );
    } else {
        return (<Loading />);        
    }
}